import ActionTypes from 'core/actions/actionTypes';
import IConfigService from "../service/config/IConfigService";
import ServiceRegistry from "../util/ServiceRegistry";
import { beginAjaxCall } from './ajaxStatusActions';
import { Error } from "tslint/lib/error";
import TokenSession from "../util/session/TokenSession";
import Logger from "core/util/Logger";
import StartupException from "../util/exception/StartupException";

export function loadLayoutSuccess(layout) {
	return { type: ActionTypes.LAYOUT_LOAD_SUCCESS, layout };
}

export const loadLayout = () => {
	return (dispatch) => {

		dispatch(beginAjaxCall());

		const configService = ServiceRegistry.get(IConfigService);

		return configService.getLayout().then((response: any) => {
			return JSON.parse(response);
		}).then(response => {
			return JSON.parse(response.data.layout);
		}).then((data: any) => {
			dispatch(loadLayoutSuccess(data));
		}).catch((error) => {
			// Fatal, kick the user back to the gateway for a new token
			throw new StartupException("Failed to fetch layout", error);
		});
	};
};

export const panelAdd = (instance: string) => {
	return { type: ActionTypes.LAYOUT_PANEL_ADD, instance};
};



// WEBPACK FOOTER //
// ./src/core/actions/layoutActions.ts